export default {
  continueButton: require('./continuebutton.svg'),
  continueButtonHover: require('./continue-button-hover.svg'),
  continueButtonActive: require('./continue-button-pressed.svg')
};
